import Isotope from "isotope-layout";
import Swiper from "swiper";

export const getCookie = (name) => {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }

  return null;
};

export const getParents = (elem) => {
  var parents = [];
  while (elem.parentNode && elem.parentNode.nodeName.toLowerCase() !== "body") {
    elem = elem.parentNode;
    parents.push(elem);
  }
  return parents;
};

export const addZeroBeforeNumber = (number) => {
  return number > 9 ? number : `0${number}`;
};

export const initializeSwiper = (item, params) => {
  const swiper_el = new Swiper(item, params);
  swiper_el.init();
  return swiper_el;
};

export const initializeIsotop = (item) => {
  let filter_menu = item.closest(".grid-wrapper").querySelector(".filter-menu");

  const grid = new Isotope(item, {
    itemSelector: ".grid-item",
    layoutMode: "masonry",
    percentPosition: true,
    stagger: 0,
    masonry: {
      columnWidth: ".grid-sizer",
    },
  });

  setTimeout(() => {
    grid.arrange({ filter: `*` });
  }, 1000);

  filter_menu &&
    filter_menu.querySelectorAll("li").forEach((el) => {
      el.querySelector("span").addEventListener("click", function (e) {
        let element = e.target,
          filtered_text = element.getAttribute("data-filter");

        filter_menu
          .querySelectorAll("li")
          .forEach((elm) => elm.classList.remove("active"));
        element.closest("li").classList.add("active");
        grid.arrange({
          filter: filtered_text === "*" ? "*" : `.${filtered_text}`,
        });
      });
    });

  return grid;
};

export const InputField = (value) => {
  document.querySelectorAll(".quantity").forEach((item) => {
    let num = value ? value : 0,
      el = item.querySelector(".qty-text"),
      plusBtn = item.querySelector(".qty-plus"),
      minusBtn = item.querySelector(".qty-minus");

    plusBtn.addEventListener("click", () => {
      num = num + 1;
      el.setAttribute("value", num);
    });

    minusBtn.addEventListener("click", () => {
      num = num > 0 ? num - 1 : 0;
      el.setAttribute("value", num);
    });

    el.setAttribute("value", num);
  });
};

export const sendEmail = async (data) => {
  const req = await fetch(`${process.env.REACT_APP_API_URL}/send`, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => data);
  return await req;
};

export const resetForm = (actions, recaptcha) => {
  if (actions) {
    actions.resetForm();
    actions.setStatus(true);
    actions.setSubmitting(false);
    setTimeout(() => actions.setStatus(false), 5000);
  }

  if (recaptcha) {
    recaptcha.current.reset();
    recaptcha.current.captcha.classList.remove("error");
  }
};

// Format date to a readable format
export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

// Set header menu position
export const SetHeaderMenuPos = () => {
  const header = document.querySelector("header");
  const stickyHeaders = document.querySelectorAll(".sticky-header");
  const headerHeight = header?.offsetHeight;

  stickyHeaders.forEach(function (stickyHeader) {
    stickyHeader.style.top = headerHeight + "px";
  });
};

// Set document full height
export const setDocumentFullHeight = () => {
  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  document.documentElement.style.setProperty(
    "--viewport-height",
    `${window.innerHeight}px`
  );
  document.documentElement.style.setProperty(
    "--document-height",
    `${documentHeight}px`
  );
};

// Strip HTML tags from string
export const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

// Get excerpt from text
export const getExcerpt = (text, maxLength = 150) => {
  const strippedText = typeof text === 'string' ? stripHtml(text) : '';
  return strippedText.length > maxLength 
    ? `${strippedText.substring(0, maxLength)}...` 
    : strippedText;
};

// Generate SEO-friendly slug
export const generateSlug = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

// Get image URL from Strapi format
export const getImageUrl = (picture, format = 'medium') => {
  if (picture?.data?.attributes?.formats?.[format]?.url) {
    return `https://panel.imigo.app${picture.data.attributes.formats[format].url}`;
  }
  if (picture?.data?.attributes?.url) {
    return `https://panel.imigo.app${picture.data.attributes.url}`;
  }
  return 'https://panel.imigo.app/uploads/medium_logo_baf7005f31.jpg';
};

// Get post type URL
export const getPostTypeUrl = (postType) => {
  if (!postType) return '';
  
  const type = typeof postType === 'string' 
    ? postType 
    : postType?.data?.attributes?.name || '';
    
  return type.toLowerCase();
};

// Get post URL
export const getPostUrl = (post) => {
  if (!post) return '/';
  
  // Always prefer slug over ID for SEO-friendly URLs
  const slug = post.attributes?.slug;
  const id = post.id;
  const urlIdentifier = slug || id; // Prefer slug, fall back to ID
  const postType = getPostTypeUrl(post.attributes?.post_type);
  
  return `/${postType}/${urlIdentifier}`;
};

// Handle API errors
export const handleApiError = (error) => {
  console.error('API Error:', error);
  return {
    message: error.response?.data?.error?.message || 'An error occurred',
    status: error.response?.status || 500
  };
};
